/**
 * Copyright 2024-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Maybe } from "~/generated/graphql";
import type { ResourceWithOs } from "~/components/resourceGroup/types";
import { SidebarItem } from "~/hooks/useGetResources";
import { ColumnType, SelectionMethod } from "~/types";

export const mapResourceToItem = (
  resource: Maybe<ResourceWithOs> | undefined,
  method: SelectionMethod
): SidebarItem => ({
  name: resource?.name ?? "",
  id: resource?.id ?? "",
  tag: method,
  columns: [
    {
      data: [resource?.os?.subType ?? "", resource?.os?.type ?? ""],
      type: ColumnType.os,
    },
    {
      data: [resource?.name ?? "", resource?.id ?? ""],
      type: ColumnType.text,
    },
    {
      data: [method],
      type: ColumnType.selectionMethod,
    },
  ],
});

export const mapResourceToSelectedItem = (
  resource: Maybe<ResourceWithOs> | undefined
): SidebarItem => mapResourceToItem(resource, SelectionMethod.manual);

export const mapResourcesToItems = (
  resources: Array<Maybe<ResourceWithOs>> | null | undefined,
  method: SelectionMethod
) => (resources ?? []).map((r) => mapResourceToItem(r, method));
